import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './locales/config';
import './styles/theme.css';
import './styles/global.css';
import './styles/App.css';

import Header from './components/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import Sharpening from './pages/Sharpening';
import Contact from './pages/Contact';
import Support from './pages/Support';

const App = (): JSX.Element => {
  return (
    <Router>
      <div className="app">
        <Header />
        <main className="main-content">
          <div className="background-image"></div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/sharpening" element={<Sharpening />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
